export default "__VITE_ASSET__CkIv7qS0__"